import * as React from 'react';

import * as main from '../styles/main.module.scss';
import * as courseTopics from '../styles/courseTopics.module.scss';

export const CourseTopics = () => {
  return (
    <section className={courseTopics.courseTopics}>
      <div className={'container'}>
        <div className={courseTopics.courseTopics__wrapper}>
          <p className={`${main.mainTitle} ${courseTopics.courseTopics__title}`}>Темы, которые мы разберём на курсе:</p>
          <div className={'row'}>
            <ul className={`col-lg-4 ${courseTopics.courseTopics__list}`}>
              <li className={`${courseTopics.courseTopics__topic} ${courseTopics.courseTopics__text}`}>глагол to be</li>
              <li className={`${courseTopics.courseTopics__topic} ${courseTopics.courseTopics__text}`}>
                указательные местоимения
              </li>
              <li className={`${courseTopics.courseTopics__topic} ${courseTopics.courseTopics__text}`}>артикли</li>
              <li className={`${courseTopics.courseTopics__topic} ${courseTopics.courseTopics__text}`}>
                конструкции <br />
                there is / there are
              </li>
            </ul>

            <div className={`col-lg-4 ${courseTopics.courseTopics__logo}`}></div>

            <ul className={`col-lg-4 ${courseTopics.courseTopics__list}`}>
              <li className={`${courseTopics.courseTopics__topic} ${courseTopics.courseTopics__text}`}>
                употребление <br />
                many / much / few / little
              </li>
              <li className={`${courseTopics.courseTopics__topic} ${courseTopics.courseTopics__text}`}>
                предлоги места
              </li>
              <li className={`${courseTopics.courseTopics__topic} ${courseTopics.courseTopics__text}`}>
                употребление <br />
                some- / any- / no-
              </li>
              <li className={`${courseTopics.courseTopics__topic} ${courseTopics.courseTopics__text}`}>
                Present&nbsp;Simple, Present Continuous, Past&nbsp;Simple, Future
              </li>
            </ul>
          </div>
          <div className={`row ${courseTopics.courseTopics__information}`}>
            <div className={`col-lg-5 ${courseTopics.courseTopics__topic} ${courseTopics.courseTopics__topicLarge}`}>
              <span className={courseTopics.courseTopics__subtitle}>Курс состоит из:</span>
              <span>10 видеоуроков</span>
            </div>
            <div className={`col-lg-5 ${courseTopics.courseTopics__topic} ${courseTopics.courseTopics__topicLarge}`}>
              <span className={courseTopics.courseTopics__subtitle}>Среднее время прохождения курса:</span>
              <span>10 часов</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
